module.exports = __webpack_public_path__ + "fonts/edex-icons.43c9d8b6.ttf";